var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13305",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_21",
    fill: "#414141",
    d: "M34.9,43.9H10.1c-3.9,0-7.1-3.2-7.1-7.1V12c0-3.9,3.2-7.1,7.1-7.1h1.2V10 c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6V4.9h15.1V10c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.9h2.2c3.9,0,7.1,3.2,7.1,7.1 v24.9C42,40.7,38.8,43.9,34.9,43.9L34.9,43.9z M10.7,13.4c-2.9,0-5.3,2.4-5.3,5.3v17.5c0,2.9,2.4,5.3,5.3,5.3h23.5 c2.9,0,5.3-2.4,5.3-5.3V18.7c0-2.9-2.4-5.3-5.3-5.3L10.7,13.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    fill: "#414141",
    d: "M12.8,11.3c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.3c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 c0.7,0,1.2,0.5,1.2,1.2l0,0V10C14.1,10.7,13.5,11.3,12.8,11.3L12.8,11.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    fill: "#414141",
    d: "M31.1,11.3c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.3c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 c0.7,0,1.2,0.5,1.2,1.2l0,0V10C32.3,10.7,31.8,11.3,31.1,11.3L31.1,11.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4526",
    fill: "#414141",
    d: "M11.8,16.6L11.8,16.6c1.9,0,3.5,1.6,3.5,3.5v14.1c0,1.9-1.6,3.5-3.5,3.5l0,0 c-1.9,0-3.5-1.6-3.5-3.5V20.1C8.3,18.2,9.9,16.6,11.8,16.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4528",
    fill: "#414141",
    d: "M22.4,16.6L22.4,16.6c1.9,0,3.5,1.6,3.5,3.5v14.1c0,1.9-1.6,3.5-3.5,3.5l0,0 c-1.9,0-3.5-1.6-3.5-3.5V20.1C18.9,18.2,20.5,16.6,22.4,16.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4530",
    fill: "#414141",
    d: "M33,16.6L33,16.6c1.9,0,3.5,1.6,3.5,3.5v14.1c0,1.9-1.6,3.5-3.5,3.5l0,0 c-1.9,0-3.5-1.6-3.5-3.5V20.1C29.4,18.2,31,16.6,33,16.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekly);
export default __webpack_public_path__ + "static/media/weekly.13a5a8b5b08a79859c07aa5c153c7ee9.svg";
export { ForwardRef as ReactComponent };